import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { SurfaceContextProvider } from '@clds/design-system-foundations';
import { layoutCommon } from './layoutCommon';

export interface MobileProps {
  leftColumn: ReactNode;
  rightColumn: ReactNode;
}

const Root = styled.div`
  ${layoutCommon};
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${(props) => props.theme.spacing.xxs};
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const RightColumn = styled.div``;

export const GuestBarLayoutMobile: FC<MobileProps> = ({ leftColumn, rightColumn, ...rest }) => (
  <SurfaceContextProvider variant="error" tone="solid">
    <Root mode="solidContrast" variant="error" intensity="md" {...rest}>
      <LeftColumn>{leftColumn}</LeftColumn>
      <RightColumn>{rightColumn}</RightColumn>
    </Root>
  </SurfaceContextProvider>
);
